import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import { API_HOME_NAME, HOME_INIT_URL } from '#home/constants';
import { InitResponseType } from '#home/api';

const getApiHome = (diContainer: Container) => createApi({
  reducerPath: API_HOME_NAME,
  baseQuery: getBaseQuery(diContainer),
  endpoints: (builder) => ({
    init: builder.query<InitResponseType, void>({
      query: () => ({
        url: HOME_INIT_URL,
      }),
    }),
  }),
});

export { getApiHome };
